import React from 'react';
import { useTheme } from '../context/ThemeContext';
import './Logo.css';

function Logo() {
  const { theme } = useTheme();
  const logoSrc = theme === 'light' 
    ? '/assets/logo-navy.png' 
    : '/assets/logo-white.png';

  return (
    <div className="logo-container">
      <img 
        src={logoSrc} 
        alt="Logo" 
        className="logo-image"
      />
    </div>
  );
}

export default Logo;
